import React, { Component } from 'react';
import './../../assets/css/App.css';
import CustomChart from './../../component/chart'
import Service from './service';

class ChartView extends Component {
    state = {
        emptyTableMessage: 'No data can be found',
        renderChart : false
    }

    componentDidMount () {
        Service.fetchAverageRevenueShipmentStats(60);

        Service.event.onFetchAverageRevenueShipmentPerDayChartData.add((data) => {
            this.setState({
                renderChart : true,
                responseTableData: data,
                histogramChartCategoriesList: data.chartData.categoryList,
                histogramChartSeriesDataList1: data.chartData.seriesDataList1
            });
        });
    }

    componentWillUnmount() {

    }

    render() {
        const options = {
            title: {
                text: 'Average Revenue/Shipments for last two month'
            },
            xAxis: {
                categories: this.state.histogramChartCategoriesList
            },
            yAxis: {
                title: {
                    text: 'Average Revenue/Shipments'
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:11px"><b>Date: {point.x}</b></span><br>',
                pointFormat: '<span style="color:{point.color}">{series.name}: </span><b>${point.y}</b>'
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '${point.y:.2f}',
                    }
                }
            },
            chart: {
                type: 'areaspline'
            },
            series: [{
                name: 'Average Revenue/Shipments',
                data: this.state.histogramChartSeriesDataList1
            }]
        };
        return (
            <div className="graph-width">
                { this.state.renderChart ? <CustomChart options={options}/> : '' }
            </div>
        );
    }
}

export default ChartView;